module.exports = __webpack_public_path__ + "img/create-launch.4bc14818.svg";